(function () {
    'use strict';

    angular.module("imApp").factory("countersService", ['$ihttp', function ($ihttp) {
        let service = {
            getCounters: function (parms) {
                return $ihttp.post({
                    method: 2554,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
